import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NumericFormat from "../react-number-format/NumericFormat";
import { useUiPreferencesContext } from "../../contexts/UiPreferencesContext";
import { urlSearchParams } from "../../constants";
var InvestmentItemMentionSpan = function InvestmentItemMentionSpan(props) {
  var linksDisabled = props.linksDisabled,
    display = props.display,
    investmentItemId = props.investmentItemId,
    eventId = props.eventId,
    investmentItemMentionId = props.investmentItemMentionId,
    prices = props.prices;
  var _useUiPreferencesCont = useUiPreferencesContext(),
    uiPreferences = _useUiPreferencesCont.uiPreferences;
  var queryString = urlSearchParams({
    investmentItemMentionId: investmentItemMentionId,
    eventId: eventId
  });
  function renderPriceVariation(prices) {
    var last = prices[0];
    var oneBeforeLast = prices[1];
    var percentage = oneBeforeLast && (last.effectiveValue / oneBeforeLast.effectiveValue - 1) * 100;
    return /*#__PURE__*/React.createElement("span", null, "\xA0", /*#__PURE__*/React.createElement(NumericFormat, {
      displayType: "text",
      prefix: percentage > 0 ? "+" : "",
      value: percentage,
      suffix: "%",
      decimalScale: 2,
      className: percentage < 0 ? "text-danger" : "text-success"
    }));
  }
  return linksDisabled ? /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, display, prices && prices.length > 1 && renderPriceVariation(prices)) : /*#__PURE__*/React.createElement(Link, {
    to: "/investment-items/".concat(investmentItemId, "/").concat(uiPreferences.investmentItemActiveTab).concat(queryString)
  }, display, prices && prices.length > 1 && renderPriceVariation(prices));
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var postId = ownProps.postId,
    investmentItemId = ownProps.investmentItemId;
  var key = [postId, investmentItemId].join("-");
  var investmentItemMentionListItem = state.entities.investmentItemMentionListItems.byPostIdAndInvestmentItemId[key];
  var investmentItemMentionId, prices;
  if (investmentItemMentionListItem) {
    investmentItemMentionId = investmentItemMentionListItem.investmentItemMentionId;
    var _investmentItemId = investmentItemMentionListItem.investmentItemId;
    var fromPriceInstant = investmentItemMentionListItem.fromPriceInstant;
    var toPriceInstant = investmentItemMentionListItem.toPriceInstant;
    var dateFormat = investmentItemMentionListItem.dateFormat;
    var _key = [_investmentItemId, fromPriceInstant, toPriceInstant, dateFormat].join("-");
    prices = state.entities.prices.byVariantInvestmentItemIdAndInstantBetweenGroupByDateFormat[_key];
  }
  return {
    investmentItemMentionId: investmentItemMentionId,
    prices: prices
  };
};
export default connect(mapStateToProps)(InvestmentItemMentionSpan);
InvestmentItemMentionSpan.defaultProps = {
  linksDisabled: false
};
InvestmentItemMentionSpan.propTypes = {
  linksDisabled: PropTypes.bool,
  display: PropTypes.string,
  postId: PropTypes.number,
  investmentItemId: PropTypes.number,
  eventId: PropTypes.number,
  investmentItemMentionId: PropTypes.number,
  prices: PropTypes.array
};